module.exports = __webpack_public_path__ + "h5/img/cygn7.8081930e.png";